import { render, staticRenderFns } from "./CarouselArrow.vue?vue&type=template&id=23518ad4&scoped=true"
import script from "./CarouselArrow.vue?vue&type=script&lang=ts"
export * from "./CarouselArrow.vue?vue&type=script&lang=ts"
import style0 from "./CarouselArrow.vue?vue&type=style&index=0&id=23518ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23518ad4",
  null
  
)

export default component.exports